export default __webpack_public_path__ + "static/media/home-hero.b99240c9.png";